import getConfig from 'next/config'
import jwtDecode from 'jwt-decode'
import { get } from '../../../../lib/fetch'
import { getCurrentHost } from '../../../../utils/Utils'

const PROMPT_EXPIRY_WARNING = 1 // minutes
const LOGOUT_BEFORE_EXPIRY = 0
const FPM_HOMEPAGE = '/fpm'

const {
  publicRuntimeConfig: { STRUDEL_API },
} = getConfig()

const FPM_CREDENTIALS = 'fpm_creds'

export const getCredentials = () =>
  new Promise((res, rej) => {
    try {
      const credentials = window.localStorage.getItem(FPM_CREDENTIALS)

      const parsedCreds = JSON.parse(credentials)

      res(parsedCreds)
    } catch (err) {
      rej('something is happening in get credentials')
    }
  })

export const fetchMemberProfile = async () => {
  try {
    const fpmCreds = await getCredentials()

    if (!fpmCreds) {
      throw new Error('no token')
    }

    const results = await get(
      `${getCurrentHost()}/members/id/${fpmCreds.memberId}`,
      {
        headers: {
          'x-token': `Bearer ${fpmCreds.token}`,
        },
      }
    )

    return {
      ...results,
      fpmCreds,
      fpmAPI: STRUDEL_API,
      refetch: fetchMemberProfile,
    }
  } catch (error) {
    throw new Error(error.message)
  }
}

export const saveCredentials = creds => {
  localStorage.setItem(FPM_CREDENTIALS, JSON.stringify(creds))
}

export const logout = ({ router, session = '' }) => {
  localStorage.removeItem(FPM_CREDENTIALS)
  const query = session.length > 0 ? { session } : {}

  router?.push({ pathname: FPM_HOMEPAGE, query })
}

export const setPath = ({ router, profilePath, setIsLoading }) => {
  if (router?.pathname === profilePath) {
    setIsLoading(false)
  }

  if (router?.pathname !== profilePath) {
    router?.push(profilePath)
  }
}

export const handleFetchError = ({
  error,
  router,
  profilePath,
  setIsLoading,
}) => {
  if (error.message === 'unauthorized') {
    logout({ router })
  }
  setIsLoading(false)
  if (router?.pathname === profilePath) {
    router?.push(FPM_HOMEPAGE)
  }
}

export const checkSessionInterval = async ({
  checkSessionExpiry,
  router,
  setSessionModal,
  sessionModal,
}) => {
  getCredentials()
    .then(fpmCreds => {
      if (fpmCreds) {
        return jwtDecode(fpmCreds.token)
      }

      return null
    })
    .then(decodedToken => {
      if (!decodedToken) {
        return
      }

      checkSessionExpiry.current = setInterval(() => {
        const timeNow = new Date().getTime() / 1000

        const timeRemaining = (decodedToken.exp - timeNow) / 60

        if (timeRemaining <= LOGOUT_BEFORE_EXPIRY) {
          logout({ session: 'expired', router })
        }

        if (timeRemaining <= PROMPT_EXPIRY_WARNING && !sessionModal.show) {
          setSessionModal({
            show: true,
            timeRemaining: Math.round(timeRemaining * 60),
          })
        }
      }, 1000)
    })
}

export const doExtendSession = async refreshSession => {
  try {
    const fpmCreds = await getCredentials()

    if (!fpmCreds) {
      throw new Error('no token')
    }

    const response = await get(
      `${getCurrentHost()}/extend-fpm-session/${fpmCreds.memberId}`,
      {
        headers: {
          'x-token': `Bearer ${fpmCreds.token}`,
        },
      }
    )

    refreshSession()

    return saveCredentials({ ...fpmCreds, token: response.newToken })
  } catch (error) {
    throw new Error(error.message)
  }
}
